import React from 'react';
import PropTypes from 'prop-types';

function formatarLimite(valor, sufixo) {
  return `${valor}${sufixo}`;
}

export default function SmartLinkRange({
  label,
  value,
  onChange,
  min,
  max,
  step,
  valueFormatter,
  minLabel,
  maxLabel,
}) {
  const intervalo = max - min || 1;
  const percentual = Math.max(0, Math.min(100, ((value - min) / intervalo) * 100));
  const valorFormatado = valueFormatter(value);

  return (
    <div className="smart-link-range">
      <style>
        {`
          .smart-link-range__input {
            -webkit-appearance: none;
            appearance: none;
            width: 100%;
            height: 6px;
            border-radius: 999px;
            outline: none;
            background: linear-gradient(
              to right,
              #16a34a 0%,
              #16a34a var(--smart-link-range-progress),
              #dbeafe var(--smart-link-range-progress),
              #dbeafe 100%
            );
          }

          .smart-link-range__input::-webkit-slider-thumb {
            -webkit-appearance: none;
            appearance: none;
            width: 16px;
            height: 16px;
            border-radius: 999px;
            border: 3px solid #16a34a;
            background: #ffffff;
            box-shadow: 0 2px 6px rgba(22, 163, 74, 0.18);
            cursor: pointer;
          }

          .smart-link-range__input::-moz-range-thumb {
            width: 16px;
            height: 16px;
            border-radius: 999px;
            border: 3px solid #16a34a;
            background: #ffffff;
            box-shadow: 0 2px 6px rgba(22, 163, 74, 0.18);
            cursor: pointer;
          }

          .smart-link-range__input::-moz-range-track {
            height: 6px;
            border-radius: 999px;
            background: transparent;
          }
        `}
      </style>

      <span>{label}</span>

      <div
        style={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          gap: '10px',
          marginBottom: '10px',
        }}
      >
        <div
          style={{
            fontSize: 12,
            color: '#1e3a8a',
            fontWeight: 600,
          }}
        >
          Ajuste o nível do filtro
        </div>

        <div
          style={{
            minWidth: 52,
            padding: '4px 8px',
            borderRadius: '999px',
            backgroundColor: '#f0fdf4',
            color: '#15803d',
            fontSize: 12,
            fontWeight: 700,
            textAlign: 'center',
          }}
        >
          {valorFormatado}
        </div>
      </div>

      <input
        type="range"
        min={min}
        max={max}
        step={step}
        value={value}
        onChange={(event) => onChange(Number(event.target.value))}
        className="smart-link-range__input"
        style={{
          '--smart-link-range-progress': `${percentual}%`,
        }}
      />

      <div
        style={{
          marginTop: '8px',
          display: 'flex',
          justifyContent: 'space-between',
          gap: '12px',
          fontSize: 11,
          color: '#64748b',
          fontWeight: 600,
        }}
      >
        <span>{minLabel || formatarLimite(min, '')}</span>
        <span>{maxLabel || formatarLimite(max, '')}</span>
      </div>
    </div>
  );
}

SmartLinkRange.propTypes = {
  label: PropTypes.string.isRequired,
  value: PropTypes.number.isRequired,
  onChange: PropTypes.func.isRequired,
  min: PropTypes.number,
  max: PropTypes.number,
  step: PropTypes.number,
  valueFormatter: PropTypes.func,
  minLabel: PropTypes.string,
  maxLabel: PropTypes.string,
};

SmartLinkRange.defaultProps = {
  min: 0,
  max: 100,
  step: 1,
  valueFormatter: String,
  minLabel: '',
  maxLabel: '',
};
